import { useState } from "react";
import { Hero, Track } from "./components/Hero";
import { Wizard } from "./Wizard";

export function App() {
  const [track, setTrack] = useState<Track | undefined>();

  if (!track) {
    return (
      <Hero
        onBegin={(t) => {
          setTrack(t);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    );
  }
  return <Wizard track={track} />;
}
